import React from 'react';
import './App.css';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import {getRazorpayKey} from "./helper";
import {PAYMENT_LABEL_MAPPING} from "./App";

export default class Razorpay extends React.Component {
    constructor(props) {
        super(props);
        this.openCheckout = this.openCheckout.bind(this);
    }

    openCheckout() {
        let self = this;
        var rzp = new window.Razorpay({
            key: getRazorpayKey(window.location.origin, this.props.paymentType),
            amount: parseInt(this.props.amount) * 100,
            currency: "INR",
            name: "Tangent India",
            description: "Payment for Order " + this.props.orderId,
            image: "https://assets.tangentindia.org/assets/main-logo.webp",
            order_id: this.props.razorpay.id,
            callback_url: 'https://payments.tangentindia.org/success',
            prefill: {
                name: this.props.name,
                email: this.props.email,
                contact: this.props.phone
            },
            notes: {
                order_id: this.props.orderId,
                ti_method: 'rzp',
                clubNum: this.props.paymentInfo.clubNum,
                name: this.props.paymentInfo.name,
                email: this.props.paymentInfo.email,
                paymentType: PAYMENT_LABEL_MAPPING[this.props.paymentInfo.paymentType]['label'],
                phone: this.props.paymentInfo.phone,
                purpose: this.props.paymentInfo.purposeDescriptor + ' - ' + this.props.paymentInfo.purpose,
                purposeDescriptor: this.props.paymentInfo.purposeDescriptor,
                consent: this.props.paymentInfo.consent,
                amount: this.props.amount + ' (includes Convenience Fee of ' + this.props.convenienceFee + ')',
                productList: this.props.paymentInfo.notes
            },
            theme: {
                color: "#3B6EB6"
            },
            handler: function (response) {
                self.setState({
                    success: true
                })
            }
        });
        rzp.on('payment.failed', function (response) {
            self.setState({
                failed: true,
                response: response
            })
        });
        rzp.open();
    }

    render() {
        if (!this.props.razorpay) {
            return (
                <div style={{display: 'flex', justifyContent: 'center'}} className='mid-margin'><CircularProgress/>
                </div>
            );
        }

        // TODO: Reload to a new page with a Success Info?
        if (this.state && this.state.success) {
            return (
                <Alert severity="success">Thank you for your payment! Your order will be processed as soon as your
                    payment is confirmed by our bank.</Alert>
            );
        }

        let failedMessage = '';
        if (this.state && this.state.failed) {
            failedMessage = (
                <Alert severity="error">
                    {'Your payment failed with error code: ' + this.state.response.error.code + ' and description: ' + this.state.response.error.description + '. Please try again or use a different payment method.'}
                </Alert>
            )

        }

        return (
            <div>
                {failedMessage}
                <div className="center mid-margin"><Button variant="contained" onClick={this.openCheckout}>Pay
                    Now</Button></div>
            </div>
        );
    }
}